// Enum: lime.graphics.ImageType

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

// Imports

var $estr = require("./../../estr_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Definition

var ImageType = $hxEnums["lime.graphics.ImageType"] = { __ename__ : "lime.graphics.ImageType", __constructs__ : ["CANVAS","DATA","FLASH","CUSTOM"]
  ,FLASH: {_hx_index:2,__enum__:"lime.graphics.ImageType",toString:$estr}
  ,DATA: {_hx_index:1,__enum__:"lime.graphics.ImageType",toString:$estr}
  ,CUSTOM: {_hx_index:3,__enum__:"lime.graphics.ImageType",toString:$estr}
  ,CANVAS: {_hx_index:0,__enum__:"lime.graphics.ImageType",toString:$estr}
};

exports.default = ImageType;